import { EnumConfigOption, globalStore } from './index';
import { GlobalApi } from '../global/GlobalApi';

const enumOptionsByType = (type: number): EnumConfigOption[] => {
    switch (type) {
        case 1: return globalStore.enumConfigs.meetingOptions;
        case 2: return globalStore.enumConfigs.bizLineOptions;
        case 4: return globalStore.enumConfigs.taskStatusOptions;
        case 5: return globalStore.enumConfigs.taskTypeOptions;
        default: return [];
    }
};

const updateEnumConfigByType = async (type: number, options?: EnumConfigOption[]): Promise<boolean> => {
    const payload = options ?? enumOptionsByType(type);
    const ok = await updateEnumConfigByTypeAndOptions(payload);
    if (ok) {
        await globalStore.loadEnumConfigsByType(type);
    }
    return ok;
};

const updateEnumConfigByTypeAndOptions = async ( options: EnumConfigOption[]) : Promise<boolean> =>{
    const result = await GlobalApi.updateEnumConfigs(options);
    return typeof result === 'string' ? false : !!result;
}


export const globalApi ={
    updateEnumConfigByType
}